"use client";
import IsaMessage from "./_sections/isa-message";
import IsaGraph from "./_sections/isa-tool";

export default function IsaToolPage() {
  return (
    <section className="bg-gradient-to-tl to-slate-900 from-gbci-primary -mb-16 px-page-xl">
      <IsaMessage></IsaMessage>
      <IsaGraph></IsaGraph>
    </section>
  );
}
